import { queryOptions } from '@tanstack/react-query';

import { getInvoiceQuery, getInvoicesInfiniteQueryOptions, getInvoicesQuery } from './shared';

export const getInvoiceQueryOptions = (id: string) => queryOptions(getInvoiceQuery(id));
export const getInvoicesQueryOptions = () => queryOptions(getInvoicesQuery());
export { getInvoicesInfiniteQueryOptions };
